import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash-es";

export default class extends Controller {
  static values = { wait: { type: Number, default: 500 } };

  change() {
    (this.debouncedDispatch ||= debounce(
      this.onDebounce.bind(this),
      this.waitValue,
    ))();
  }

  flush() {
    this.debouncedDispatch?.flush();
  }

  disconnect() {
    this.debouncedDispatch?.cancel();
  }

  onDebounce() {
    this.dispatch("onDebounce");
  }
}
